module.exports = {	
	'Connect Wallet' : 'ウォレットを接続する',
	'Lossless mining' : 'ロスレスマイニング',
	'Liquidity pledge-free' : '流動性の誓約なし',
	'Reward' : '褒美',
	'Million' : '100万',
	'Receive Voucher' : 'バウチャーを受け取る',
	'Invite Friends' : '友達を招待',
	'Mining Pool' : 'マイニングプール',
	'Account' : 'アカウント',

	'Pool data' : 'プールデータ',
	'Valid node' : '有効なノード',
	'Participant' : '参加者',
	'User Revenue' : 'ユーザー収益',
	'Mining' : '鉱業',
	'Liquidity mining income' : '流動性鉱業収入',
	'User Output' : 'ユーザー出力',
	'Address' : '住所',
	'Help center' : 'ヘルプセンター',
	'Hope it helps you' : 'それがあなたを助けることを願っています',
	'How do i need to join？' : 'どうやって参加すればいいですか?',
	'Participating in non-destructive and non-guaranteed liquidity mining requires payment of ETH miner fees to receive the replacement gold coupons, and the ETH wallet address only needs to be claimed once. Automatically open mining permissions after success.' : '非破壊的かつ非保証的な流動性マイニングに参加するには、ETHウォレットアドレスを一度だけ受け取るために、ETH坑夫費を支払う必要がある。成功するとマイニングの権限が自動的にオンになる。',
	'How do i withdraw money？' : 'どうやってお金を引き出しますか？',
	'You can convert the currency generated every day into USDT, and then initiate a withdrawal. USDT withdrawals will be automatically sent to the wallet address you added to the node, other addresses are not supported.' : '毎日生成される通貨をUSDTに交換し、キャッシュアウトを開始することができます。USDTキャッシュは、ノードに追加したウォレットアドレスに自動的に送信され、他のアドレスはサポートされません。',
    'How to calculate income？':'収入はどのように計算しますか？',
    'When you join successfully, the smart contract starts to calculate your address through the node and start to calculate the revenue.' : '参加が成功すると、スマートコントラクトはノードを介してアドレスを計算し、収益を計算し始めます。',
	'What is revenue？':'収益率とは何か。？',
	'The yield below1000USDT≈0.5%~0.6%,' : '1000USDT以下の収益率は0・5 ~0・6%。',
    '1000USDT-5000USDT≈1.6%~2.0%, ' : '1000USDT~ 5000USDT能1.6% ~ 2.0%だが、',
    '5000USDT-20000USDT yield≈1.8%~2.2%, ' : '5000USDT-2000USDT収益率は約1.8%~2.2%。',
    '20000USDT-50000USDT yield≈2.2%~2.6%, ' : '20000USDT -50000USDT収益率≒2.2%~2.6%',
    '50000USDT-200000USDT yield≈2.6%~3.0%, ' : '50000USDT -200000USDT収益率は2.6%~3%。',
    'and above 200000USDT yield Rate≈2.8%~3.5% ' : '200000USDT以上の収益率≒2.8%~3.5%',
    'What are the extra gains？' : '追加の収穫は何ですか？',
    'You can share our page to a friend, if he joins, you can get 10% of his income as a bonus,your sharing link is on the top left corner of the homepage to get.' : 'あなたは私達のページを友達に分かち合うことができて、もし彼が加入するならば、あなたは彼の収入の10%を獲得することができてボーナスとして、あなたの分かち合うリンクはトップページの左上の角で獲得します。',
	'My account' : 'マイアカウント',
	'Total output' : '総出力',
	'Wallet balance' : 'ウォレットの残高',
	'Exchangeable' : '交換可能',
	'Withdrawable' : '抽出可能',
	'Exchange' : '交換',
	'Withdraw' : '撤退',
	'Record' : '記録',
	'Redeem all' : 'すべて引き換える',
	'Total balance' : '総合収支',
	'Confirm' : 'Confirm',
	'Time' : '時間',
	'Quantity' : '量',
	'Status' : '状態',
	'No Data' : 'データなし',
	'Output' : '出力',
	'Fee' : '手数料',
	'Scope' : '範囲',
	'Daily acceptance times' : '毎日の受付回数',
	'Your withdrawal will be sent to your USDT wallet address within 24 hours in the future' : '引き出しは、24時間以内にUSDTウォレットアドレスに送信されます',
	'Audit report' : '監査報告書',
	'We have a secure audit report' : '安全な監査レポートがあります',
	'Partner' : '相棒',
	'our business partner' : '私たちのビジネスパートナー',
	'Share friends' : '友達を招待',
	'My share link' : '私の共有リンク',
	'Copy' : 'コピー',
	"Send your invitation link, friends join the node through your link, and you will get generous token rewards.You can get 10% of the recommended person's income" : "招待リンクを送信すると、友達があなたのリンクを介してノードに参加し、あなたは寛大なトークン報酬を受け取ります。あなたは推薦された人の収入の10％を得ることができます",
	'There was an issue signing you in.' : 'サインイン中に問題が発生しました。',
	'Receive description' : '説明を受け取る',
	"You need to pay a miner's fee to receive the voucher, please make sure that your wallet has enough ETH as the miner's fee" : "バウチャーを受け取るには鉱夫の料金を支払う必要があります。ウォレットに鉱夫の料金として十分なETH/TRXがあることを確認してください",
	"Receive" : "受け取る",
	"You have successfully joined the node and started mining" : "ノードに正常に参加し、マイニングを開始しました"
}


// WEBPACK FOOTER //
// ./src/assets/lang/jp.js